import { styled, useTheme } from 'styled-components'
import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'

const Debris = ({ imageSrc }: { imageSrc: string }) => {
  const theme = useTheme()
  const darkSuffix = theme.colorMode === 'dark' ? '-dark' : ''

  return (
    <Container>
      {/* <TextWidth>
        General locations of items recovered. Some parts could have come from different locations than shown
        </TextWidth> */}
      <ContentWidth>
        <Content>
          <Item>
          <Image src={require(`../MainComponent/debris-1${darkSuffix}.png`)} alt={'Capot du moteur'} />
          <Text>
            <Title>Capot du moteur</Title>
            <div>Les empattements sur le logo Rolls-Royce correspondent aux pochoirs
            utilisés par Malaysian Airlines.</div>
          </Text>
          </Item>
          <Item>
          <Image src={require(`../MainComponent/debris-2${darkSuffix}.png`)} alt={'Carénage de volet'} />
          <Text>
            <Title>Carénage de volet</Title>
            <div>La police de caractères correspond aux pochoirs utilisés par la
            compagnie malaisienne.</div>
          </Text>
          </Item>
          <Item>
          <Image src={require(`../MainComponent/debris-3${darkSuffix}.png`)} alt={'Gouverne'} />
          <Text>
            <Title>Gouverne</Title>
            <div>Le marquage des éléments de fixation correspond à ceux utilisés
            sur la ligne de production de l’appareil disparu.</div>
          </Text>
          </Item>
        </Content>
      </ContentWidth>
      <TextWidth>
        <Source>Source: Ministère des transports de Malaisie</Source>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div``

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  max-width: 600px;
`

const Item = styled.div`
  display: flex;
  align-items: center;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 20px;
  border-bottom: 1px solid rgb(${({ theme }) => theme.color.grey});

  &:last-child {
    border-bottom: none;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
  }
`

const Text = styled.div`
border-left: 1px solid rgb(${({ theme }) => theme.color.grey});
height: 100%;
padding: 20px;
box-sizing: border-box;

${({ theme }) => theme.breakpoints.down('md')} {
  border-left: none;
}
`

const Content = styled.div`
  line-height: 1.35;
`

const Source = styled.div`
  font-size: 0.65em;
  margin-top: 2em;
`

const Title = styled.span`
  background-color: ${({ theme }) => `rgb(${theme.color.main})`};
  color: white;
  padding: 0.1em 0.65em;
  display: inline-block;
  margin-bottom: .65em;
`

export default Debris
